var _rect, _rect2, _rect3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgslider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#EFF0F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.575,
    y: 11.0537,
    width: 3.85,
    height: 5.85,
    rx: 1.425,
    stroke: "#292D32",
    strokeWidth: 1.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.575,
    y: 0.575,
    width: 3.85,
    height: 5.85,
    rx: 1.425,
    transform: "matrix(-1 0 0 1 19.85 10.4787)",
    stroke: "#292D32",
    strokeWidth: 1.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7386 12.8V15.2C17.7386 17.2 17.0012 18 15.1576 18H12.9452C11.1016 18 10.3641 17.2 10.3641 15.2V12.8C10.3641 10.8 11.1016 10 12.9452 10H15.1576C17.0012 10 17.7386 10.8 17.7386 12.8Z",
    fill: "#EFF0F4",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgslider);
export default __webpack_public_path__ + "static/media/imgslider.099d9e70.svg";
export { ForwardRef as ReactComponent };